import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { Observable } from 'rxjs';
import { AuditService } from 'src/app/core/audit.service';
import { PosizioniService } from 'src/app/core/posizioni.service';
import { AuditSearchFilters, AuditSearchRequest, AuditSearchResponse } from 'src/app/shared/models/audit.model';
import { Posizione } from 'src/app/shared/models/posizione.model';

@Component({
  selector: 'app-audit',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <app-audit-filters [posizioni]="posizioni$ | async" (updateFiltersAndSearch)="updateFiltersAndSearch($event)">
    </app-audit-filters>
    <app-audit-table [auditEvents]="auditEvents()" (updateRequestAndSearch)="updateRequestAndSearch($event)">
    </app-audit-table>
`
})
export class AuditComponent implements OnInit {
  public posizioni$!: Observable<Posizione[]>;
  public auditEvents = signal<AuditSearchResponse>({
    originalRequest: { pageFirstRow: 0, pageSize: 20, sortField: 'DataEvento', sortOrder: -1 }
  } as AuditSearchResponse);

  private auditService = inject(AuditService);
  private posizioniService = inject(PosizioniService);

  ngOnInit(): void {
    this.posizioni$ = this.posizioniService.getPosizioni();
  }

  public updateFiltersAndSearch(filters: AuditSearchFilters): void {
    this.doSearch({ ...this.auditEvents().originalRequest, ...{ filters } as AuditSearchRequest });
  }

  public updateRequestAndSearch(request: AuditSearchRequest): void {
    this.doSearch({ ...this.auditEvents().originalRequest, ...request });
  }

  private doSearch(request: AuditSearchRequest) {
    this.auditService.search(request).subscribe(a => {
      this.auditEvents.set(a);
    });
  }
}
